import React from 'react';

const PasswordResetForm = ({ email, setEmail, loading, error, handleSubmit }) => {

  return (
    <div className="login-main login-main-forgot-password">
      <div className="login-main-header text-center mb-4">
        <div className="login-avatar-container mx-auto mb-3">
          <div className="login-avatar-outer mx-auto">
            <div className="login-avatar-inner mx-auto">
              <svg width="41" height="41" viewBox="0 0 41 41" className="login-avatar-image" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.4375 17.0312C24.1999 17.0312 27.25 13.9812 27.25 10.2188C27.25 6.45631 24.1999 3.40625 20.4375 3.40625C16.6751 3.40625 13.625 6.45631 13.625 10.2188C13.625 13.9812 16.6751 17.0312 20.4375 17.0312Z"
                    stroke="#404040" stroke-width="2.55469"/>
                <path
                    d="M34.0591 30.6562C34.0614 30.3769 34.0625 30.0931 34.0625 29.8047C34.0625 25.5724 27.9619 22.1406 20.4375 22.1406C12.9131 22.1406 6.8125 25.5724 6.8125 29.8047C6.8125 34.037 6.8125 37.4688 20.4375 37.4688C24.2372 37.4688 26.9775 37.2014 28.9531 36.7245"
                    stroke="#404040" stroke-width="2.55469" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
        </div>

        <h2 className="login-title mb-3">Проверьте почту</h2>

        <p className="login-description">
          Введите почту, на которую мы отправим письмо с новыми данными для входа
        </p>
      </div>

      <div className="login-form">
        {error && <div className="login-error mb-3">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Почта</label>
            <div className="input-group">
              <div className="password-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M1.66667 10C1.66667 6.8575 1.66667 5.28584 2.64334 4.31C3.62001 3.33417 5.19084 3.33334 8.33334 3.33334H11.6667C14.8092 3.33334 16.3808 3.33334 17.3567 4.31C18.3325 5.28667 18.3333 6.8575 18.3333 10C18.3333 13.1425 18.3333 14.7142 17.3567 15.69C16.38 16.6658 14.8092 16.6667 11.6667 16.6667H8.33334C5.19084 16.6667 3.61917 16.6667 2.64334 15.69C1.66751 14.7133 1.66667 13.1425 1.66667 10Z"
                      stroke="#404040"/>
                  <path
                      d="M5 6.66664L6.79917 8.16664C8.33 9.44164 9.095 10.0791 10 10.0791C10.905 10.0791 11.6708 9.44164 13.2008 8.16581L15 6.66664"
                      stroke="#404040" stroke-linecap="round"/>
                </svg>
              </div>
              <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-mail"
                  disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary-filled w-100"
            disabled={loading}
          >
            {loading ? 'Отправляем...' : 'Отправить письмо'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;
